import {
  apiKeyCreateResponseSchema,
  apiKeyListResponseSchema,
  apiKeySchema,
  type ApiKey,
  type ApiKeyCreateResponse,
  type CreateApiKeyInput,
} from "@repo/shared";

import { API_V1_PREFIX, apiRequestData, apiRequestJson } from "../api-client";

export async function listApiKeys(): Promise<ApiKey[]> {
  const response = await apiRequestJson({
    path: `${API_V1_PREFIX}/api-keys`,
    responseSchema: apiKeyListResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
  return response.data;
}

export async function createApiKey(
  input: CreateApiKeyInput,
): Promise<ApiKeyCreateResponse["data"]> {
  const response = await apiRequestJson({
    path: `${API_V1_PREFIX}/api-keys`,
    method: "POST",
    body: input,
    responseSchema: apiKeyCreateResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
  return response.data;
}

export async function revokeApiKey(id: string): Promise<ApiKey> {
  return apiRequestData({
    path: `${API_V1_PREFIX}/api-keys/${id}/revoke`,
    method: "POST",
    dataSchema: apiKeySchema,
    badResponseMessage: "Unexpected response from server",
  });
}
